import { ServiceType } from "@agroyaar/sdk";
// @ts-ignore
import filedLogo from "../../../../../../public/assets/icons/logofilled.png";
import { reportBackgroundColor } from "../../../utils/report-color";

interface FooterIntroductionProps {
  serviceType: ServiceType;
  footerCaption: string;
}

const FooterIntroduction = ({
  serviceType,
  footerCaption,
}: FooterIntroductionProps) => {
  const reportBackground = reportBackgroundColor(serviceType);

  return (
    <div className="flex flex-col items-center justify-end gap-[2rem] w-full mt-auto">
      <div className="relative w-full h-[73px] flex bg-white">
        <span
          className="absolute bottom-0 left-0 w-full h-[48px] rounded-br-[60rem] blur-[1px] rotate-180"
          style={{ background: reportBackground }}
        />
        <p className="absolute top-[40px] right-[24px] text-white font-bold text-[11px]">
          {footerCaption}
        </p>
        <p className="absolute top-[24px] right-[24px] text-white font-bold text-[24px]"></p>
        <div className="absolute top-0 left-[44px] flex items-center gap-[32px] bg-[rgba(255,255,255,0.4)] border border-[rgba(255,255,255,0.31)] rounded-[13px] backdrop-blur-[16px] p-[4px_8px] glassshadow">
          <span className="text-[#028442] font-bold text-[28px]">
            پلتفرم جامع خدمات کشاورزی اگرویار
          </span>
          <div className="flex items-center gap-[8px]">
            <img src={filedLogo} alt="logo" className="h-[40px]" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterIntroduction;
